import {isEmpty} from "es-toolkit/compat";

export const getBiomarkerLevels = marker => {
  if (isEmpty(marker)) return [];

  return [
    {
      x: "low",
      y: marker.biomarkerDeficientValue,
      percentage: marker?.biomarkerDeficientValueP || 0,
      rangeStatus: marker?.rangeStatus,
    },
    {
      x: "border-low",
      y: marker.biomarkerSufficientValue,
      percentage: marker?.biomarkerSufficientValueP || 0,
      rangeStatus: marker?.rangeStatus,
    },
    {
      x: "normal",
      y: marker.biomarkerHighValue,
      percentage: marker?.biomarkerHighValueP || 0,
      rangeStatus: marker?.rangeStatus,
    },
    {
      x: "border-high",
      y: marker.biomarkerToxicValue,
      percentage: marker?.biomarkerToxicValueP || 0,
      rangeStatus: marker?.rangeStatus,
    },
    {
      x: "high",
      y: marker.biomarkerHighestValue,
      percentage: marker?.biomarkerHighestValueP || 0,
      rangeStatus: marker?.rangeStatus,
    },
  ]
    .filter(level => level.percentage != 0)
    .filter(level => {
      if (marker.biomarkerHideBorderlines == 1 && ["border-low", "border-high"].includes(level.x)) {
        return false;
      }
      return true;
    });
};
